import React from 'react';
import { GeneralRoute } from '../../utils/routes';
import { NavLink, useLocation } from 'react-router-dom';

const SideBar = () => {
	const { pathname } = useLocation();
	return (
		<div className="hidden opacity-0 md:flex md:flex-col md:opacity-100 md:bg-gray-200 md:basis-1/5 pt-20 md:overscroll-none md:min-h-screen overflow-clip">
			<div className="mb-2 pl-5">
				<img src={'/spay_logo.svg'} width={100} height={100} alt={'SpayLogo'} />
			</div>
			{GeneralRoute.map((val) => (
				<div key={val.label} className="my-2 pl-5 pr-5">
					<h4 className="font-bold mb-2 text-blue text-sm">{val.label}</h4>
					{val.content.map((route) => (
						<div
							key={route.path}
							className={
								pathname === route.path
									? 'border-2 border-gray bg-gray-50 p-2 rounded-md'
									: ' p-2'
							}
						>
							<NavLink to={route.path}>
								<h4 className="text-sm">{route.name}</h4>
							</NavLink>
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default SideBar;
